var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cookie',{attrs:{"cookietext":_vm.cookietext,"cookiebutton":_vm.cookiebutton,"cookietextcolor":_vm.cookietextcolor,"cookietextsize":_vm.cookietextsize,"cookiebackgroundcolor":_vm.cookiebackgroundcolor,"cookiename":_vm.cookiename,"cookievalue":_vm.cookievalue,"cookieexdays":_vm.cookieexdays}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }